import React from "react";
import { withAppState, getAppState } from "../../state";
import { withFocusable } from "../../services/visualLibraryService";
import { ImageStyled, LogoWrapperStyled, LogoShadeStyled } from "./styles/Styled";
import MainMenuContainer from "../MainMenuContainer";
import FreeLogo from "../../components/FreeLogo";
import AdmnLogo from "../../components/FreeLogo/AdmnLogo";
import { getLogger } from "../../utils/logger";
import { findFromBrands } from "../../helpers/find";
import { directions, i18n } from "../../services/i18nService";
import Logo from "../../components/Logo";
import { getCurrentProfile } from "../../services/multipleProfilesService";
import { getPath } from "../../utils/getPath";
import packageJson from "../../../package.json";

const appVersionQueryParameter = `?version=${packageJson?.version}`;

const MainMenuContainerFocus = withFocusable(MainMenuContainer);

let isBrand;

let slider;

export const defaultFocusPath = "mainMenu";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: false,
      loaded: false,
      menuExpanded: false
    };
    this.handleFocusMenu = this.handleFocusMenu.bind(this);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.navigate = this.navigate.bind(this);
    this.logger = getLogger();
    this.brandName = null;
    this.imageUrlSubscription = "";
    this.imageUrlBrands = "";
    this.isActiveBrand = false;
    this.isLive = false;
  }

  componentDidUpdate() {
    let { addons } = this.props.applicationState;
    isBrand = window.location.pathname.indexOf("brands/");
    const names = isBrand && window.location.pathname.split("/");
    this.isLive = window.location.pathname.split("/")[1] === "live" ? true : false;
    if (isBrand && isBrand !== -1) {
      this.brandName = names[2];
      let subscription = findFromBrands(this.brandName, this.props.applicationState.subscriptions || []);
      let baseSubscription = findFromBrands(this.brandName, subscription?.brands);
      this.isActiveBrand = getAppState()?.addons?.find(
        addon =>
          (addon.name === subscription?.displayName || addon.name === this.brandName) &&
          addon?.status?.toLowerCase() === "active"
      );
      this.imageUrlSubscription =
        subscription?.displayName === "STARZPLAY"
          ? `${baseSubscription?.configuration.logoDefaultPNG}`
          : `${subscription?.configuration.logoDefaultPNG}${appVersionQueryParameter}`;
    } else {
      this.brandName = null;
    }
  }

  handleFocusMenu(focused) {
    this.setState({ activeMenu: focused });
  }

  navigate() {
    slider.navigate();
    slider.rightMenuHandler();
    this.handleToggleMenu(false);
  }

  up() {
    slider.left();
  }

  down() {
    slider.right();
  }
  left() {
    slider.left();
  }

  right() {
    slider.rightMenuHandler();
    // slider.right();
  }
  handleToggleMenu(focused) {
    this.setState({ menuExpanded: focused });
  }

  render() {
    const isAdmnDetailRoute =
      /^\/admn\/movies\/[^/]+$/.test(window.location.pathname) ||
      /^\/admn\/series\/[^/]+$/.test(window.location.pathname);
    const isAdmnRoute = /^\/admn/.test(window.location.pathname);

    const isRootPath = window.location.pathname !== "/" ? true : false;
    const isSubManu =
      window.location.pathname.startsWith("/admn/") || window.location.pathname.startsWith("/category/");

    return (
      <>
        {isBrand != 1 || this.isActiveBrand ? (
          <>
            {!this.isLive && <LogoShadeStyled></LogoShadeStyled>}
            <LogoWrapperStyled brandName={this.brandName}>
              {isAdmnDetailRoute ? (
                ""
              ) : isAdmnRoute ? (
                <AdmnLogo height={"auto"} />
              ) : window.location.pathname === "/brands" && !this.brandName ? (
                this.isLive ? (
                  ""
                ) : (
                  <Logo height={"4.14vh"} width={"15.47vw"} />
                )
              ) : !this.brandName && !this.isLive ? (
                <FreeLogo />
              ) : (
                !this.isLive && <ImageStyled src={this.imageUrlSubscription} alt={this.brandName} />
              )}
            </LogoWrapperStyled>
          </>
        ) : null}
        {!this.brandName && !isSubManu && (
          <MainMenuContainerFocus
            focusPath={defaultFocusPath}
            handleFocus={this.handleFocusMenu}
            onRef={ref => (slider = ref)}
            onLeft={i18n.getDirection() !== directions.LEFT_TO_RIGHT ? this.right : () => {}}
            onRight={i18n.getDirection() === directions.LEFT_TO_RIGHT ? this.right : () => {}}
            onDown={this.down}
            onUp={this.up}
            onEnterPress={this.navigate}
            handleToggleMenu={this.handleToggleMenu}
            menuExpanded={this.state.menuExpanded}
          />
        )}
      </>
    );
  }
}

Header.defaultFocusPath = defaultFocusPath;

export default withAppState(Header);
